@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.regionNav {
    text-align: center;
    margin: 0.3125rem;
}

.regionNavLink {
    composes: baseButton from "../../styles/buttons.module.scss";
    background-color: var(--color-white);
    color: var(--color-mid-gray);

    @include breakpoint.breakpoint(layout.$belowMedium) {
        background-color: var(--color-crystal-bell);
        color: var(--color-mid-gray);
        text-transform: uppercase;
    }
}
